(() => {
  function openInquiry() {
    const form = document.getElementById('product-request-form');
    if (!form) return false;
    const disclosure = form.querySelector('details');
    if (disclosure) disclosure.open = true;
    form.scrollIntoView({behavior: 'smooth', block: 'center'});
    const name = form.querySelector('input[name="contact[name]"]');
    if (name) name.focus({preventScroll: true});
    return true;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-od-dispatch-inquiry]');
    if (link && link.getAttribute('href') === '#product-request-form') {
      if (openInquiry()) event.preventDefault();
      else if (link.dataset.odDispatchFallback) {event.preventDefault(); window.location.assign(link.dataset.odDispatchFallback);}
    }
  });
  if (window.location.hash === '#product-request-form') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openInquiry, {once: true});
    else openInquiry();
  }
})();
